// Call plugin.
import * as actionTypes from '../actionTypes'

// Libraries.
import { isEmpty } from 'lodash/fp'

function sessionActionHelper (type, id, payload = {}, meta = {}) {
  const action = {
    type,
    payload: {
      ...payload,
      id
    }
  }

  // Only have meta and error properties on the action if they're needed.
  if (!isEmpty(meta)) {
    action.meta = meta
  }
  if (payload.error) {
    action.error = true
  }
  return action
}

export function sessionAdded (id, params) {
  return sessionActionHelper(actionTypes.SESSION_ADDED, id, params)
}

export function sessionRemoved (id, params) {
  return sessionActionHelper(actionTypes.SESSION_REMOVED, id, params)
}

export function sessionNewTrack (id, params) {
  return sessionActionHelper(actionTypes.SESSION_NEW_TRACK, id, params)
}

export function sessionTrackEnded (id, params) {
  return sessionActionHelper(actionTypes.SESSION_TRACK_ENDED, id, params)
}

export function sessionChange (id, params) {
  return sessionActionHelper(actionTypes.SESSION_CHANGE, id, params)
}

export function sessionTrackReplaced (id, params) {
  return sessionActionHelper(actionTypes.SESSION_TRACK_REPLACED, id, params)
}

export function sessionIceConnectionStateChange (id, params) {
  return sessionActionHelper(actionTypes.SESSION_ICE_CONNECTION_STATE_CHANGE, id, params)
}

export function sessionIceGatheringStateChange (id, params) {
  return sessionActionHelper(actionTypes.SESSION_ICE_GATHERING_STATE_CHANGE, id, params)
}

export function sessionIceCandidateCollected (id, params) {
  return sessionActionHelper(actionTypes.SESSION_ICE_CANDIDATE_COLLECTED, id, params)
}

export function sessionIceCollectionScheduledCheck (id, params) {
  return sessionActionHelper(actionTypes.SESSION_ICE_COLLECTION_SCHEDULED_CHECK, id, params)
}
